module.exports = __webpack_public_path__ + "static/media/Sub-2-Building-Use-Restrictions-Westbriar-Village.4ea247d2.pdf";